import { tvServiceOrder } from "./constants";

/** Initial Customize Order state objects */
const initialState = {
    pageLoadType: 'I', // I - Inital, R - revisit, C- Chang Plan
    isCheckoutPageVisited: 'N',
    isSaveCartPageVisited: 'N',
    isSavedCartOfferApplied: 'N',
    IsETFBuyOutQualified : 'N',
    yellowPageHeadings: [],
    isSelectedBundleTN :'',
    serviceCallOpt: false,
    selectedOpt: 'N',
    isBDVBundle: true,
    TvRecordValue :'',
    isCheckoutEnableBDV:false,
    showSBSModal: false,
    disableVAS: false,
    // isCheckoutEnableBDV:false,
    isInternetFlowCompleted: false,
    // for Bundle Conversion
    allSelectedPlans: [],
    isBannerFlow: 'N',
    isCPAK: 'N',
    addTvSubHeader :'',
    negotiatedServices: [],
    allFlowRequestPayLoads: [],
    servicesInCart: '',
    selectedStaticIPId: '',
    // request payload...
    allSelectedNonDoBundle: [],
    // bundle plans..
    allSelectedNonDoBundlePlans: [],
    phoneServiceType: '',
    internetServiceType: '',
    isBundleOffersFlow: '',
    selectedContract: "2 year agreement", //GTSCD-2740 - default selection should be 2 year agreement not No annual contract
    selectedPhoneEqupmentIds: [],
    isFlowChanged: 'N',
    isReverseFlow: 'Y',
    selectedPremiumSupportPlans: [],
    selectedBundlePlanDetails: {}, getYahooCatDetails: { YslBusAddress: '', YslBusCategories: [] },
    yahooFormData: { businessName: '', businessCategory: '', businessPhone: '', isBillingPhoneRequired: 'Yes', categoryName: '' },
    yahooEligibilityResponse: { success: '', potentialDuplicate: '' },
    yahooEligibilityResponseMsg: '',
    showYahooMsg: false,
    showYahooFrm: false,
    showTechTeamFrm: false,
    techTeamFormData: { FirstName: '', LastName: '', Phone: '', Email: '' },
    selectedYahooPackage: '',
    sampleData: 'something',
    bundleOptions: null,
    selectedBundleOptions: [],
    selectedBundleOptionsProducts: ['internet', 'phone'],
    selectedInternetPlan: {},
    nfNoOfLinesSet: false,
    nfPhoneFlowComplete: false,
    nfNoOfLines: {},
    nfStandardLine: {},
    nfPhoneEquipments: {},
    Is911ServiceAccepted : false,
    nfEquipmentType: '',
    nfTvHdSetup: false,
    nfDirectoryListing: {},
    nfAccordianStatus: {
        plan: false,
        internet: false,
        phone: false,
        addons: false
    },
    bdvEquipmentList: [],
    nfIsRouterSelected: false,
    isRouterFirstTime: true,
    isImmediateChange: false,
    BlueJeansProducts: [
        {
            "ActualPrice": "",
            "Contract": "",
            "IPType": null,
            "IsRC": false,
            "IsSelected": false,
            "PackageId": null,
            "PlanIncluded": null,
            "Price": "0",
            "ProductId": "0",
            "ProductName": "I do not need BlueJeans Meetings",
            "ServiceType": "FIOS",
            "ShortDesc": null,
            "SiteCatelist": null
        },
        {
            "ActualPrice": "12.49",
            "Contract": "NoContract",
            "IPType": null,
            "IsRC": false,
            "IsSelected": false,
            "PackageId": null,
            "PlanIncluded": null,
            "Price": "12.49",
            "ProductId": "25614990",
            "ProductName": "BlueJeans Meetings Standard",
            "ServiceType": "FIOS",
            "ShortDesc": null,
            "SiteCatelist": null
        },
        {
            "ActualPrice": "17.49",
            "Contract": "NoContract",
            "IPType": null,
            "IsRC": false,
            "IsSelected": false,
            "PackageId": null,
            "PlanIncluded": null,
            "Price": "17.49",
            "ProductId": "25614991",
            "ProductName": "BlueJeans Meetings Pro",
            "ServiceType": "FIOS",
            "ShortDesc": null,
            "SiteCatelist": null
        }
    ],
    internetRouterList: [],
    nfNoOfLinesComplete: false,
    toggleCartLoading: false,
    retrieveCartMON: '',
    retrieveCartID: '',
    source:"",
    tvViewSelection: {},
    bundleRecommendFlow: false,
    selectedProductsRouterList: [],
    checkEquipmentAdded : false,
    IsBlueJeansMeetingStandardChecked:0,
    serviceReqCheck: false,
    selectedBlueJeansLicense: '1',
    getCustApiTriggered: false,
    enableRouterNotification:false,
    enablePhoneNotification:false,
    enableEquipmentNotification:false,
    bdvwPhoneLines:[],
    bdvwequipmentPhone:{},
    enableWebexSection: false,
    enableSelectLinesBDVW: true,
    enableEquipmentBDVW:false,
    enableFeaturesBDVW:false,
    equipSectionVisitedBDVW: false,
    featuresSectionVisitedBDVW: false,
    bdvwEquipVisited: false,
    bdvwFeaturesVisited: false,
    saveFeatureChecked:{},
    emailValidationFailureCount:0,
    vds3ChannelInfo:"Local TV",
    nfIPSelected: "Dynamic",
    ipSectionSelected: false,
    vzwOfferEligibilityResponseStatus:"",
    isPhoneEquipmentSelectionDone:false,
    planTileSelected: false,
};
// nf- new Flow

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_POST_LQ_DATA_RESPONSE':
            return { ...state, getPostLqData: action.data };
        case 'UPDATE_TN_FOR_LISTING':
            return { ...state, nfTnForListing: action.data };
        case 'UPDATE_PHONE_SUCCESS':
            return { ...state, updatePhoneSuccess: action.data };
        case 'POST_SAVE_CART_INVALID':
            return { ...state, invalidPostSaveCart: action.data };
        case 'USE_YOUR_OWN_NUMBER':
            return { ...state, useYourOwnNumberRes: action.data };
            case 'RESET_WIN_BACK_TN':
                return { ...state, useYourOwnNumberRes: '' };
            
        case 'JOINT_OFFER_AVAILABILITY_RESPONSE':
            return { ...state, jointOfferAvailResponse: action.data };
        case 'VZW_OFFER_ELIGIBLITY_RESPONSE':
            return { ...state, vzwOfferEligibilityResponse: action.data };
        case 'VZW_OFFER_ELIGIBLITY_RESPONSE_STATUS':
            return {...state,vzwOfferEligibilityResponseStatus: action.data};
        case 'GET_SELECTED_BUNDLEINFO_RESPONSE':
            return { ...state, getSelectedBundleInfoRes: action.data };
        case 'GET_YELLOW_PAGE_RES':
            return { ...state, yellowPageHeadings: action.data };
        case 'GET_INTERNET_FLOW_RES':
            return { ...state, internetFlowDataRes: action.data };
        case 'GET_STANDALONE_INTERNET_FLOW_RES':
            return { ...state, standaloneInternetFlowDataRes: action.data };
        case 'GET_STANDALONE_TV_FLOW_RES':
            return { ...state, standaloneTvFlowDataRes: action.data };
        case 'GET_SABDV_RESPONSE':
            return { ...state, getSABdv: action.data };
        case 'GET_BDV_BUNDLE_RESPONSE':
            return { ...state, getBDVBundleResp: action.data };
        case 'GET_PREFERRED_VOICE_RESPONSE':
            return { ...state, getPreferredVoice: action.data };
        case 'UPDATE_INTERNET_DATA_SUCCESS':
            return { ...state, internetDataRes: action.data };
        case 'SAVE_STATE_DETAILS':
            return { ...state, savedState: action.data };
        case 'GET_FLOAT_CART_RESPONSE':
            return { ...state, getFloatCartResponse: action.data };
        case 'UPDATE_GET_FLOAT_CART_RESPONSE':
            return { ...state, getFloatCartResponse: action.data };
        case 'GET_FIOS_TV_RESPONSE':
            return { ...state, getFiosTvResponse: action.data };
        case 'UPDATE_FIOS_TV_SUCCESS':
            return { ...state, updateFiosTvRes: action.data };
        case 'SET_BANNER_INTERNET_SECTION':
            return { ...state, bannerInternetSelection: action.data };
        case 'SAVE_YAHOO_CATEGORY_DETAILS':
            return { ...state, getYahooCatDetails: action.data };
        case 'SAVE_YAHOO_DUPE_CHECK_SUC_RESPONSE':
            return { ...state, yahooFormData: action.data.params, yahooEligibilityResponse: action.data.response, yahooEligibilityResponseMsg: action.data.responseMsg };
        case 'SET_YAHOO_FORM_DATA':
            return { ...state, yahooFormData: action.data };
        case 'SAVE_YAHOO_DUPE_CHECK_UPD_SUC_RESPONSE':
            return { ...state, yahooEligibilityResponseMsg: action.data.responseMsg };

        case 'SAVE_YAHOO_DUPE_CHECK_FAILED_RESPONSE':
            return { ...state, yahooEligibilityResponse: '', yahooEligibilityResponseMsg: '' };
        case 'SET_YAHOO_FORM_TO_DEFAULT':
            return {
                ...state, yahooFormData: { businessName: '', businessCategory: '', businessPhone: '', isBillingPhoneRequired: '', categoryName: '' },
                yahooEligibilityResponse: { success: '', potentialDuplicate: '' },
                yahooEligibilityResponseMsg: ''
            };
        case 'SET_YAHOO_ELIGIBILITY_RESPONSE_TO_DEFAULT':
            return { ...state, yahooEligibilityResponse: '', yahooEligibilityResponseMsg: '' };

        case 'REMOVE_INTERNET_BANNER_SPEED':
            return { ...state, bannerInternetSelection: action.data };

        case 'SET_BANNER_TV_SECTION':
            return { ...state, bannerTVSelection: action.data };

        case 'SET_BANNER_PHONE_SECTION':
            return { ...state, bannerPhoneSelection: action.data };

        case 'SET_ALL_FLOW_REQUEST_PAYLOADS':
            let allFlowRequestPayLoads = state.allFlowRequestPayLoads;
            if (action.params) {
                if (allFlowRequestPayLoads?.length > 0) {
                    // existing....
                    let eachReqPayloadIdx = allFlowRequestPayLoads.findIndex((plan) => plan.id === action.params.id);
                    if (eachReqPayloadIdx > -1) {
                        allFlowRequestPayLoads[eachReqPayloadIdx].selectedPlans = action.params.selectedPlans;
                    } else {
                        //new entry...
                        allFlowRequestPayLoads.push(action.params);
                    }
                } else {
                    //new entry...
                    allFlowRequestPayLoads.push(action.params);
                }
            }
            return { ...state, allFlowRequestPayLoads: allFlowRequestPayLoads };

        case 'SET_FLOW_STATUS':
            let servicesNegotiated = state.negotiatedServices;
            if (action.params) {
                if (servicesNegotiated?.length > 0) {
                    // existing....
                    let flowIdx = servicesNegotiated.findIndex((plan) => plan.id === action.params.id);
                    if (flowIdx > -1) {
                        servicesNegotiated[flowIdx].status = action.params.status;
                    } else {
                        //new entry...
                        servicesNegotiated.push(action.params);
                    }
                } else {
                    //new entry...
                    servicesNegotiated.push(action.params);
                }
            }
            return { ...state, negotiatedServices: servicesNegotiated };
        case 'UPDATE_ALL_SELECTED_PLANS':
            let allSelectedPlans = state.allSelectedPlans;
            if (action.params) {
                if (allSelectedPlans?.length > 0) {
                    // existing....
                    let eachUpdateIdx = allSelectedPlans.findIndex((plan) => plan.id === action.params.id);
                    if (eachUpdateIdx > -1) {
                        allSelectedPlans[eachUpdateIdx].selectedPlans = action.params.selectedPlans;
                    } else {
                        //new entry...
                        allSelectedPlans.push(action.params);
                    }
                } else {
                    //new entry...
                    allSelectedPlans.push(action.params);
                }
            }
            return { ...state, allSelectedPlans: allSelectedPlans };

        case 'REMOVE_PHONE_BANNER_DATA':
            return { ...state, bannerPhoneSelection: action.data };
        case 'REMOVE_TV_BANNER_DATA':
            return { ...state, bannerTVSelection: action.data };
        case 'SET_CONTRACT_TYPE':
            return { ...state, selectedContract: action.data };

        case 'SAVE_NAV_PRICE':
            return { ...state, navHeaderPrice: action.data };

        case 'UPDATE_TV_VIEW':
            return { ...state, tvViewType: action.data };

        case 'UPDATE_SERVICES_IN_CART':
            return { ...state, servicesInCart: (action.params || action.data) };
            
        case 'UPDATE_SERVICES_CALL_REQ':
            return { ...state, isServiceCallAccepted: action.data }; 

            case 'UPDATE_SERVICES_IN_CART_BDV':
                return { ...state, servicesInCart: action.data };
            

        case 'IS_CPAK_APPLICABLE':
            return { ...state, isCPAK: action.data };

        case 'IS_BANNER_FLOW':
            return { ...state, isBannerFlow: action.data };

        case 'IS_BUNDLE_OFFER_FLOW':
            return { ...state, isBundleOffersFlow: action.data };

        case 'IS_FLOW_CHANGED':
            return { ...state, isFlowChanged: action.params };

        case 'IS_REVERSE_FLOW':
            return { ...state, isReverseFlow: action.params };

        case 'UPDATE_PHONE_SERVICES':
            return { ...state, phoneServiceType: action.params };
        case 'UPDATE_DATA_SERVICES':
            return { ...state, internetServiceType: action.params };
        case 'UPDATE_ALL_SELECTED_NON_DO_BUNDLE_PLANS_INFO':
            let allSelectedNonDoBundleInfo = state.allSelectedNonDoBundle;
            if (action.params) {
                if (allSelectedNonDoBundleInfo?.length > 0) {
                    // existing....
                    let eachBundleInfoUpdateIdx = allSelectedNonDoBundleInfo.findIndex((plan) => plan.id === action.params.id);
                    if (eachBundleInfoUpdateIdx > -1) {
                        allSelectedNonDoBundleInfo[eachBundleInfoUpdateIdx].selectedPlans = action.params.selectedPlans;
                    } else {
                        //new entry...
                        allSelectedNonDoBundleInfo.push(action.params);
                    }
                } else {
                    //new entry...
                    allSelectedNonDoBundleInfo.push(action.params);
                }
            }
            return { ...state, allSelectedNonDoBundle: allSelectedNonDoBundleInfo };

        case 'SET_SELECTED_NON_DO_BUNDLE_PLANS':
            let allSelectedBundlePlansFromNonDo = state.allSelectedNonDoBundlePlans;
            if (action.params) {
                if (allSelectedBundlePlansFromNonDo?.length > 0) {
                    // existing....
                    let eachBundlePlanIdx = allSelectedBundlePlansFromNonDo.findIndex((plan) => plan.id === action.params.id);
                    if (eachBundlePlanIdx > -1) {
                        allSelectedBundlePlansFromNonDo[eachBundlePlanIdx].selectedPlans = action.params.selectedPlans;
                    } else {
                        //new entry...
                        allSelectedBundlePlansFromNonDo.push(action.params);
                    }
                } else {
                    //new entry...
                    allSelectedBundlePlansFromNonDo.push(action.params);
                }
            }
            return { ...state, allSelectedNonDoBundlePlans: allSelectedBundlePlansFromNonDo };
        case 'SELECTED_PHONE_EQUIPMENT':
            let selectedEquipment = state.selectedPhoneEqupmentIds;
            selectedEquipment = action.params;
            return { ...state, selectedPhoneEqupmentIds: selectedEquipment };

        case 'SET_INTERNET_TYPE':
            return { ...state, InternetType: action.data };
        case 'SET_ROUTER_LIST':
            return { ...state, internetRouterList: action.data };
        case 'RESET_BUNDLE_CONVERSION_PROPERTIES':
            return {
                ...state,
                allSelectedPlans: [],
                isBannerFlow: 'N',
                negotiatedServices: [],
                allFlowRequestPayLoads: [],
                servicesInCart: '',
                allSelectedNonDoBundle: [],
                allSelectedNonDoBundlePlans: [],
                phoneServiceType: '',
                isBundleOffersFlow: 'N',
                isFlowChanged: 'N',
                isReverseFlow: 'Y',
                selectedBundlePlanDetails: {},
            };
        case 'SET_SELECTED_PRODUCT_TYPE':
            return {
                ...state,
                selectedProductType: action.data
            }
        case 'SELECTED_BUNDLE_INFO_REQUEST_BODY_FOR_TV':
            return {
                ...state,
                selectedBundleInfoRequestBodyForTv: action.data
            }
        case 'UPDATE_INTERNET_PLAN_ID':
            return {
                ...state,
                selectedInternetPlanID: action.internetPlanID
            }
        case 'UPDATE_PREMIUM_SUPPORT_SELECTION':
            let selectedPremiumSupportPlans = state.selectedPremiumSupportPlans;
            let temp = selectedPremiumSupportPlans?.filter(plan => plan.id === action.data.id);

            if (temp?.length > 0) {
                temp[0].selectedPremiumSupport = action.data.selectedPremiumSupport;
            } else {
                selectedPremiumSupportPlans.push(action.data);
            }

            return {
                ...state,
                selectedPremiumSupportPlans: selectedPremiumSupportPlans
            }
        case 'UPDATE_SELECTED_PLAN_DETAILS':
            let selectedDetailPlanInfo = {
                selectedPlanId: action.data.planId,
                selectedProperty: action.data.property,
                selectedPlan: action.data.plan,
            };
            return {
                ...state,
                selectedBundlePlanDetails: selectedDetailPlanInfo
            }

        case 'RESET_SELECTED_PLAN_DETAILS':
            return {
                ...state,
                selectedBundlePlanDetails: {}
            }
        case 'SET_BUNDLEOPTIONS_SELECTIONS':
            return {
                ...state,
                bundleOptions: action.data.updatedOptions,
                selectedBundleOptions: action.data.selectedOptions,
                selectedBundleOptionsProducts: action.data.selectedProducts,
            }
        case 'SET_SELECTED_BUNDLE_COMPLETED':
            return {
                ...state,
                isSelectedBundleCompleted: action.data

            }

            case 'SAVE_SELECTED_BUNDLE_TN':
            return {
                ...state,
                isSelectedBundleTN: action.data

            }
            case 'IS_Phone':
                return {
                    ...state,
                    isPhone: action.data
    
                }


        case 'UPDATE_SELECTED_INTERNET_PLAN':
            return {
                ...state,
                selectedInternetPlan: action.params
            }
        case 'SET_CUSTOMIZE_PRODUCTS_DATA':
            return {
                ...state,
                customizeProductsResponse: action.data

            }
        case 'SAVE_SELECTED_PRODUCTS':
            return {
                ...state,
                selectedProductsResp: action.data.response,
                pageLoadType: action.data.pageLoadType,
            }
        case 'SAVE_SELECTED_PRODUCTS_ROUTERS':
            return {
                ...state,
                selectedProductsRouterList: action.data,
            }
        case 'SET_NEWFLOW_INTERNET_TYPE':
            return {
                ...state,
                nfInternetType: action.data,
            }
        case 'SET_NEW_EQUIPMENT_SELECTION':
            return {
                ...state,
                nfEquipmentType: action.data
            }
        case 'SET_HD_SETUP_SELECTION':
            return {
                ...state,
                nfTvHdSetup: action.data
            }

        case 'SET_NEW_BIS_SELECTION':
            return {
                ...state,
                nfBISType: action.data
            }
        case 'SET_SMALL_BIS_LIMITATION':
            return {
                ...state,
                showSBSModal: action.data 
            }
        case 'DISABLE_VAS_PRODUCT':
            return {
                ...state,
                disableVAS: action.data 
            }   
              
        case 'SET_NEW_BIS_PREFER_SELECTION':
            return {
                ...state,
                nfBisPreferSelected: action.data
            }
        case 'SET_NEW_IP_SELECTION':
            return {
                ...state,
                nfIPSelected: action.data
            }
        case 'SET_BLOCK_IP_SELECTION':
            return {
                ...state,
                nfBlockIPSelected: action.data
            }
        case 'SHOW_BLOCK_IP_SELECTION':
            return {
                ...state,
                displayStaticIpCheckbox: action.data
            }
                
        
        case 'SET_SELECTED_IP_ID':
            return { ...state, selectedStaticIPId: action.data }; 

        case 'SET_TV_RECORDING_SELECTION':
            return {
                ...state,
                nfTVRecordingType: action.data
            }

            case 'RESET_TV_RECORDING_SELECTION':
            return {
                ...state,
                nfTVRecordingType: ''
            }

            case 'SET_TV_RECORDING_SELECTION_VALUE':
                return {
                    ...state,
                    TvRecordValue:  action.data
                }

                case 'RESET_TV_RECORDING_SELECTION_VALUE':
                    return {
                        ...state,
                        TvRecordValue:  ''
                    }
                    
            case 'SAVE_ADD_TV_SUBHEADER':
                return {
                    ...state,
                    addTvSubHeader: action.data
                }

                case 'RESET_ADD_TV_SUBHEADER':
                    return {
                        ...state,
                        addTvSubHeader: ''
                    }
            
        case 'SET_NEW_TSP_SELECTION':
            return {
                ...state,
                nfTSPSelected: action.data
            }
        case 'SET_NEW_TECHTEAM_SELECTION':
            return {
                ...state,
                nfTechTeamSelected: action.data
            }
         case 'SET_SUBMITTED_TECHTEAM_SELECTION':
            console.log("SET_SUBMITTED_TECHTEAM_SELECTION", action.data);
            return {
                ...state,
                nfTechTeamSubmitted: action.data
            }
        case 'SHOW_NEW_TECHTEAM_SELECTION':
            return {
                ...state,
                showTechTeamFrm: action.data
            }

        case 'SET_TECHTEAM_FORM_TO_DEFAULT':
            return {
                ...state, techTeamFormData: { FirstName: '', LastName: '', Email: '', Phone: '' },
            };

        case 'SET_TECHTEAM_FORM_DATA':
            return {
                ...state, techTeamFormData: action.data,
            };

        case 'SET_NEW_VERIZON_CLOUD_SELECTION':
            return {
                ...state,
                nfVZCloudSelected: action.data
            }
        case 'SET_NEW_YAHOO_LOCAL_WORKS_SELECTION':
            return {
                ...state,
                nfYLWSelected: action.data
            }
        case "SET_YLW_DATA": {
            return {
                ...state, ...action.data
            }
        }
        case 'SET_NEW_NOOFLINES_SELECTION':
            return {
                ...state,
                nfNoOfLines: action.data
            }
        case 'SET_CHECK_EQUIPMENT_ADDED':
            return {
                ...state,
                checkEquipmentAdded: action.data
            }
        case 'SET_PHONE_COMPLETION_STATUS':
            return {
                ...state,
                nfPhoneFlowComplete: action.data
            }
        case 'SET_NOOFLINES_COMPLETION_STATUS':
            return {
                ...state,
                nfNoOfLinesSet: action.data
            }
        case 'SET_NEW_STANDARDLINE_SELECTION':
            return {
                ...state,
                nfStandardLine: action.data
            }
        case 'SET_NEW_PHONEQUIPMENT_SELECTION':
            return {
                ...state,
                nfPhoneEquipments: action.data
            }
        case 'SET_NEW_DIRECTORYLISTING_SELECTION':
            return {
                ...state,
                nfDirectoryListing: action.data
            }
        case 'SET_NEW_ACCORDIAN_STATUS':
            return {
                ...state,
                nfAccordianStatus: action.data
            }
        case 'SET_SCART_ID':
            return {
                ...state,
                scartId: action.data
            }
        case 'UPDATE_SERVICE_REQ_INFO':
            return {
                ...state, [action.data.key]: action.data.value
            }
        case 'UPDATE_SERVICES_REQ_CALL_INFO':
            return {
                ...state,
                selectedOpt: action.data.selectedOpt
            }
        case 'RESET_SELECTIONS_ON_CHECKBOX_CLICK':
            return {
                ...state,
                nfBISType: '',              
                nfEquipmentType: '',
                nfTvHdSetup: false,
                nfNoOfLines: '',
                nfStandardLine: '',
                // nfDirectoryListing: '',
                nfIsRouterSelected: false,
                isRouterFirstTime: true,
                nfNoOfLinesSet: false,
                nfPhoneFlowComplete: false,
                // nfIPSelected: 'Dynamic', 
                nfBlockIPSelected:'', 
                displayStaticIpCheckbox: false,             
                selectedBlueJeansProduct: '0',
                selectedBlueJeansLicense: '',
                nfTSPSelected: '0',
                nfTechTeamSelected: '0',
                nfVZCloudSelected: '0',
                nfTVRecordingType: '',
                nfNoOfLinesComplete: false,
                nfBisPreferSelected: '0',
                showYahooMsg: false,
                showYahooFrm: false,
                showTechTeamFrm: false,
                techTeamFormData: { FirstName: '', LastName: '', Email: '', Phone: '' },
                selectedYahooPackage: '',
                nfYLWSelected: '',
                yahooFormData: { businessName: '', businessCategory: '', businessPhone: '', isBillingPhoneRequired: 'Yes', categoryName: '' },
                yahooEligibilityResponse: { success: '', potentialDuplicate: '' },
                yahooEligibilityResponseMsg: '',
                selectedInternetPlan: {},
                tvViewSelection: {},
                isTriggredBDV :false,
                tvOrder:tvServiceOrder,
                emailValidation:undefined,
                enableFeaturesBDVW:false,
                enableSelectLinesBDVW:false,
                bdvwFeaturesVisited:false,
                enableEquipmentBDVW:false,
                useYourOwnNumberRes:undefined,
                enableSelectLinesBDVW:true,
                bdvwEquipVisited:false,
                bdvwPhoneLines:[],
                bdvwequipmentPhone:{}

            }
        case 'JOINT_OFFER_DISABLE':
            return {
                ...state, isImmediateChange: action.data
            }
        case 'UPDATE_BLUEJEANS_SELECTION':
            return {
                ...state, selectedBlueJeansProduct: action.data
            }
        case 'UPDATE_BLUEJEANS_LICENSE_SELECTION':
            return {
                ...state, selectedBlueJeansLicense: action.data
            }
        case 'UPDATE_BLUEJEANS_MEETINGS_STANDARD_CHECK': 
            return {
                ...state, IsBlueJeansMeetingStandardChecked: action.data
            }
        case 'SET_ISROUTER_SELECTED':
            return {
                ...state, nfIsRouterSelected: action.data
            }

        case 'SET_ISROUTER_FIRSTTIME':
            return {
                ...state, isRouterFirstTime: action.data
            }


        case 'UPDATE_PAGELOAD_TYPE':
            return {
                ...state, pageLoadType: action.data
            }

        case 'UPDATE_SERVICE_CALL_OPT':
            return {
                ...state, serviceCallOpt: action.data
            }

        case 'UPDATE_IS_SERVICE_CALL_CHECKBOX_SELECTED':
            return {
                ...state, serviceReqCheck: action.data
            }

        case 'UPDATE_CHECKOUTPAGE_VISIT_FLAG':
            return {
                ...state, isCheckoutPageVisited: action.data
            }

        case 'SAVE_TV_PLAN':
            return {
                ...state, saveTvPlan: action.data
            }
        case 'UPDATE_SAVECARTPAGE_VISIT_FLAG':
            return {
                ...state, isSaveCartPageVisited: action.data
            }
        case 'UPDATE_IS_SAVED_CART_OFFER_APPLIED':
            return {
                ...state, isSavedCartOfferApplied: action.data
            }
        case 'UPDATE_IS_ETF_BUY_OUT_QUALIFIED':
             return {
                 ...state, IsETFBuyOutQualified: action.data
        }
             

        case 'UPDATE_BDV_EQUIPMENTS':
            return {
                ...state,
                bdvEquipmentList: action.data
            }
        
        case 'SAVE_BDV_ENHANCED_CALL':
            return {
                ...state,
                serviceCallOpt: action.data.serviceCallOpt,
                selectedOpt: action.data.selectedOpt,
                isServiceCallAccepted: action.data.isServiceCallAccepted
            }

        case "HAS_CHECKOUT_DETAILS_RESPONSE":
            return {
                ...state,
                hasCheckoutResponse: action.data
            }
        case "SET_TV_ORDER": {
            return {
                ...state,
                tvOrder: action.data
            }
        }
        case "SAVE_CURRENT_LOCATION": {
            return {
                ...state,
                currentLocation: action.data
            }
        }
        case "SET_NUMBEROFLINES_COMPLETE": {
            return {
                ...state,
                nfNoOfLinesComplete: action.data
            }
        }
        case "UPDATE_TN_LISTING_FROM_PROD_CALL": {
            return {
                ...state,
                customizeProductsResponse: {
                    ...state.customizeProductsResponse,
                    [action.data?.key]: {
                        ...state.customizeProductsResponse[action.data?.key],
                        TNList: action.data?.value?.TNList,
                        FaxLineInfo: action.data?.value?.FaxLineInfo,
                        FaxTNList: action.data?.value?.FaxTNList
                    }
                }
            }
        }
        case "UPDATE_TN_LISTING_FROM_GET_BDV_TN": {
            return {
                ...state,
                customizeProductsResponse: {
                    ...state.customizeProductsResponse,
                    [action.data?.key]: {
                        ...state.customizeProductsResponse[action.data?.key],
                        TNList: {
                            ...state.customizeProductsResponse[action.data?.key]['TNList'],
                            TNObject: action.data?.value?.TNObject
                        }
                    }
                }
            }
        }
        case "SET_GET_BDV_TN_RESP": {
            return {
                ...state, getBDVTNResp: action.data
            }
        }

        case "SET_BDV_TN_COUNT": {
            return {
                ...state, bdvTNCount: action.data
            }
        }

        case "BTN_EMPTY": {
            return {
                ...state, btnEmpty: action.data
            }
        }
        case "ONLY_SA_FIOS": {
            return {
                ...state, saFiosOnly: action.data
            }
        }
        case 'TOGGLE_CART_LOADING':
            return {
                ...state, toggleCartLoading: action.data
            };
        case 'SET_CART_MON':
            return {
                ...state, retrieveCartMON: action.data
            };
        case 'SET_CART_ID':
            return {
                ...state, retrieveCartID: action.data
            };
        case 'SET_SOURCE':
                return {
                    ...state, source: action.data
                };
        case 'SET_C_ID':
            return {
                ...state, cid: action.data
            };
        case 'SET_C_MP':
                return {
                    ...state, cmp: action.data
                };
        case 'SAVE_VIEW_SELECTION': {
            return { ...state, tvViewSelection: action.data }
        }
        case 'UPDATE_BUNDLE_RECOMMEND': {
            return { ...state, bundleRecommendFlow: action.data }
        }
        case 'SAVE_OFFER_DISCLAIMER_RESPONSE': {
            return {...state, aemOfferDisclaimer: action.data};
        }
        case 'Select_BDVBundle_ON_Internet': {
            return {...state, isBDVBundle: action.data};
        }
        case 'SET_CHECKOUT_ENABLE_BDV': {
            return {...state, isCheckoutEnableBDV: action.data};
        }
        case '911_Service_ACCEPTED': {
            return {...state, Is911ServiceAccepted: action.data};
        }
        case '911_Service_VALUE': {
            return {...state, Is911ServiceValue: action.data};
        }
        case 'INTERNER_FLOW_COMPLETED': {
            return { ...state, isInternetFlowCompleted: action.data };
        }
        case 'SET_FCC_TEMPLATE':{
            return {...state,fccTemplate:action.data}
        }
        case 'SET_FCC_TEMPLATE_API_TRIGGERED':{
            return {...state,fccTemplateApiTriggered:action.data}
        }
        case 'ENABLE_ROUTER_NOTIFICATION':{
            return {...state,enableRouterNotification:action.data}
        }
        case 'ENABLE_PHONE_NOTIFICATION':{
            return {...state,enablePhoneNotification:action.data}
        }
        case 'ENABLE_EQUIPMENT_NOTIFICATION':{
            return {...state,enableEquipmentNotification:action.data}
        }
        case 'SET_BDVW_PHONE_LINES':{
            return {...state,bdvwPhoneLines:action.data}
        }
        case 'SET_BDVW_PHONE_LINES_RESPONSE':{
            let phoneArray=action.data.map((data,i)=>({
                    LineNO:i+1,
                    OldTN:(data['TN']).replace(/-/g, ""),
                    OldPlanID:data['ProductID'],
                    OldIsWB:"",
                    NewTN:(data['TN']).replace(/-/g, ""),
                    NewPlanID:data['ProductID'],
                    NewIsWB:"",
                    selected: ((data?.SubscriberInfo?.SubscriberType) == "" ? "desktop" : (data?.SubscriberInfo?.SubscriberType)?.toLowerCase())??"desktop",
                    SubscriberInfo:{"TN":(data['TN']).replace(/-/g, ""),"SubscriberType":(data?.SubscriberInfo?.SubscriberType) == "" ? "desktop" : (data?.SubscriberInfo?.SubscriberType)?.toLowerCase(),"Email":"","IsBDVWAdmin":i+1 == 1 ? "Y" : "N"}
                })
            );
            let existingLines=[...state.bdvwPhoneLines]
            phoneArray.forEach((e)=>{
                if(existingLines.every((e1)=>e1["OldTN"]!==e["OldTN"])){
                    existingLines.push(e)
                }
            })
            return {...state,bdvwPhoneLines:existingLines,bdvTNCount:existingLines.length}
        }
        case 'SET_SELECTED_BDVW_EQUIPMENTS_PHONE':{
            return {...state,bdvwequipmentPhone:action.data}
        }
        case 'SET_ENABLE_SELCTLINES_SECTION_BDVW':{
            return {...state,enableSelectLinesBDVW:action.data, enableEquipmentBDVW : false, enableFeaturesBDVW : false }
        }
        case 'SET_ENABLE_EQUIPMENT_SECTION_BDVW':{
            return {...state,enableEquipmentBDVW:action.data, enableFeaturesBDVW : false, enableSelectLinesBDVW: false, bdvwEquipVisited : true }
        }
        case 'SET_ENABLE_FEATURE_SECTION_BDVW':{
            return {...state,enableFeaturesBDVW:action.data, enableSelectLinesBDVW: false, enableEquipmentBDVW : false, bdvwFeaturesVisited: true}
        }
        case 'SET_ENABLE_WEBEX_SECTION_BDVW':{
            return {...state,enableWebexSection:action.data}
        }
        case 'SET_FEATURES_CHECKED_BDVW':{
            return {...state,saveFeatureChecked:action.data}
        }
        case 'SET_EMAIL_VALIDATION':{
            return {...state,emailValidation:action.data}
        }case 'SET_ROUTER_SELECTED_3.0':{
            return {...state,newRouterSelected:action.data}
        }
        case 'SET_ROUTER_ERROR_NOTIFICATION_3.0':{
            return {...state,routerErrorNotification:action.data}
        }
        case "SET_SELECTED_STATIC_IP_NEW_3.0":{
            return {...state,staticIpSelectedNew:action.data}
        }
        case "SET_SELECTED_TV_VIEWING_OPTION":{
            return {...state,selectedTVOption:action.data}
        }
        case "SET_SELECTED_BAR_PEOPLE_FOC":{
            return {...state,selectedBarPeopleFoc:action.data}
        }
        case "SET_STORE_OLD_ID":{
            return {...state,storeOldID:action.data}
        }
        case "SET_STORE_EQUIPMENT":{
            return {...state,storeEquipment:action.data}
        }
        case "SET_STORE_CHANNEL":{
            return {...state,storeChannel:action.data}
        }
        case "SET_STORE_SUBTITLE":{
            return {...state,storeSubTitle:action.data}
        }
        case 'SET_EMAIL_VALIDATION_FAILURE_COUNT':{
            return {
                ...state,
                emailValidationFailureCount:action.actionType==="increment"
                ?state.emailValidationFailureCount+1
                :0
            }
        }
        case "SET_VDS3_CHANNEL_TYPE":{
            return {
                ...state,
                vds3ChannelInfo:action.data
            }
        }
        case "RESET_UPDATECART_ONPAGE_LOAD":{
            return {...state,resetUpdateCartPageLoad:true}
        }
        case 'ENABLE_INTERNET_NOTIFICATION':{
            return {...state,enableInternetNotification:action.data}
        }
        case "SET_IP_SECTION_SELECTED":{
            return {...state,ipSectionSelected:action.data}
        }
        case "SET_ROUTER_ACCORDIAN":{
            return {...state,routeraccordian:action.data}
        }
        case "IS_PHONE_EQUIPMENT_SELECTION_DONE":
            return { ...state, isPhoneEquipmentSelectionDone: action.data }
        case "SET_PLAN_TILE_SELECTED":{
            return { ...state, planTileSelected: action.data }
        }
        case "CUST_API_TRIGGERED": return {
            ...state, getCustApiTriggered: action.data
        }
        case 'UPDATE_INTERNET_ID': 
            return {
                ...state,
                selectedInternetPlanID: action.internetPlanID
            }
        default:
            return state;
    }
};
export default reducer;